/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Device} from '@ion/core/src/types/entities';
import {DeviceMoveEditor} from '@ion/dls/src/editors/DeviceMoveEditor';
import {moveAdminDevices, moveDevices} from './state';
import {
  deviceMoveResultSelector,
  deviceMoveSelectedDevicesSelector,
  deviceMoveShowLoadingSelector
} from './state-selectors';

/**
 * BulkEditDeviceEditor
 *
 */
export const BulkEditDeviceEditor = () => {
  const dispatch                  = useDispatch();
  const selectedDevices           = useSelector(deviceMoveSelectedDevicesSelector);
  const editedDevices             = useSelector(deviceMoveResultSelector);
  const loading                   = useSelector(deviceMoveShowLoadingSelector);
  const [clearForm, setClearForm] = useState(false);

  useEffect(() => {
    if (editedDevices) {
      setClearForm(true);
      dispatch(moveAdminDevices(null, false));
    }
  }, [editedDevices]);

  const onSave = useCallback((devices: Device[]) => {
    dispatch(moveDevices(devices));
  }, []);

  const onCancel = useCallback(() => {
    dispatch(moveAdminDevices(null, false));
  }, []);

  return (
    <DeviceMoveEditor open
      devices={selectedDevices}
      clear={clearForm}
      loading={loading}
      onSave={onSave}
      onCancel={onCancel} />
  );
};

export default React.memo(BulkEditDeviceEditor);
